import React from 'react'
import { Timeline, TimelineEvent } from 'react-event-timeline'

import { Box, Icon, theme } from '@driftt/dds'
import { faCalendarDay } from '@driftt/dds.icons/light/faCalendarDay'

import { DateRange } from 'components/DateRangePicker'
import useAccountActivities from 'hooks/useAccountActivities'

import CardFactory from './CardFactory'

interface ActivitiesFeedProps {
  accountId?: string
  dateRange?: DateRange
}

const ActivitiesFeed = ({ accountId, dateRange }: ActivitiesFeedProps) => {
  const { data } = useAccountActivities({ accountId, dateRange })

  return (
    <Box
      css={{
        whiteSpace: 'break-spaces',
        width: '100%'
      }}>
      {Object.keys(data).length && (
        <Timeline lineColor={theme.colors.gray4.toString()}>
          {Object.entries(data).map(([date, tasksByGroup]: any) => (
            <TimelineEvent
              icon={<Icon icon={faCalendarDay} size="large" />}
              key={date}
              createdAt={date}
              collapsible
              showContent={true}
              contentStyle={{
                backgroundColor: 'transparent',
                boxShadow: 'non'
              }}
              style={{
                fontFamily: theme.fonts.primary,
                fontSize: theme.fontSizes[2]
              }}
              bubbleStyle={{
                background: theme.colors.gray2,
                borderColor: theme.colors.gray4
              }}
              title="">
              {Object.entries(tasksByGroup).map(([group, groupedTasks]: any) => (
                <Timeline lineColor={theme.colors.pink3.toString()} key={`${date}-${group}`}>
                  {groupedTasks.map((data: any) => (
                    <CardFactory key={data.id} data={data} />
                  ))}
                </Timeline>
              ))}
            </TimelineEvent>
          ))}
        </Timeline>
      )}
    </Box>
  )
}

export default ActivitiesFeed
